import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../js/api/messaging";
import { useAuth } from "../../js/hooks/useAuth";
import { messagesPath } from "../../js/utils/messagingPaths";

export default function InquiryComposer({ desk = "agent" }) {
  const { session } = useAuth();
  const navigate = useNavigate();
  const [peers, setPeers] = useState([]);
  const [toUserId, setToUserId] = useState("");
  const [text, setText] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    api("GET", "/api/inquiries/peers", null, session).then((result) => {
      if (result.ok) setPeers(result.data || []);
    });
  }, [session]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setMessage("");
    if (!toUserId) {
      setError("Choose a colleague");
      return;
    }
    if (!String(text).trim()) {
      setError("Write a short inquiry first");
      return;
    }
    const result = await api("POST", "/api/inquiries/send", { to_user_id: toUserId, message_text: text }, session);
    if (!result.ok) {
      setError(result.error || "Could not send inquiry");
      return;
    }
    setText("");
    setMessage("Inquiry filed in Office Messaging.");
    navigate(
      messagesPath(desk, {
        office: true,
        threadId: result.data.thread_id,
        transactionId: result.data.transaction_id,
      })
    );
  }

  if (!peers.length) {
    return (
      <p className="muted">
        Office notes live in Office Messaging. Link another agent or broker to this office to send one.
      </p>
    );
  }

  return (
    <form onSubmit={handleSubmit} noValidate>
      <p className="muted">
        {desk === "broker"
          ? "Notify an agent in this office. The note is stored in Office Messaging, apart from client files."
          : "Ask another agent — or your broker — in Office Messaging, apart from client files."}
      </p>
      <label className="field">
        <span className="field-label">Send to</span>
        <select className="field-select" value={toUserId} onChange={(event) => setToUserId(event.target.value)}>
          <option value="">Choose a colleague</option>
          {peers.map((peer) => (
            <option key={peer.id} value={peer.id}>
              {peer.name} ({peer.role_type})
            </option>
          ))}
        </select>
      </label>
      <label className="field">
        <span className="field-label">Inquiry</span>
        <textarea
          className="field-textarea"
          value={text}
          onChange={(event) => setText(event.target.value)}
          rows={5}
          placeholder="A short, professional note — showing coverage, file question, or office request."
        />
      </label>
      {error ? <p className="field-error">{error}</p> : null}
      {message ? <p className="confirm-banner">{message}</p> : null}
      <button type="submit" className="primary-btn">
        Send to Office Messaging
      </button>
    </form>
  );
}
